export default __webpack_public_path__ + "static/media/emoji-maroc.533da362.svg";